"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const appConstants_1 = require("../../../../../constants/appConstants");
const strings_1 = require("../../../../../constants/strings");
const companyFeatureToggle_1 = __importDefault(require("../companyFeatureToggle"));
const TransactionReceiptUploadFeatureToggle = () => ((0, jsx_runtime_1.jsx)(companyFeatureToggle_1.default, { featureKey: appConstants_1.companyFeaturesConstants.enableTransactionReceiptUpload, label: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_TRANSACTION_RECEIPT_UPLOAD }));
exports.default = (0, react_1.memo)(TransactionReceiptUploadFeatureToggle);
